/* eslint-disable */
import { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthContext from "../context/AuthProvider";
import axios from "axios";
import Cookies from "js-cookie";
import * as Icon from "react-bootstrap-icons";
import logo from "../assets/logo.png";
import { Mixpanel } from "../Mixpanel";
import { getCustomerBranding } from "../api/customerSiaApi";

const ConsumeSso = () => {
  const authCtx = useContext(AuthContext);
  const SSO_CONSUME_URL = authCtx.ssoConsumeUrl;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const authToken = localStorage.getItem("authToken")
    ? localStorage.getItem("authToken").slice(1, -1)
    : "";
  
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [brandingLogo, setBrandingLogo] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    
    if (!token) {
      setError(true);
      setMessage("No SSO token found in URL");
      setLoading(false);
      return;
    }

    // Clean the token (remove quotes if present)
    const cleanToken = token.replace(/"/g, "");
    
    consumeSsoToken(cleanToken);
  }, [searchParams]);

    useEffect(() => {
    const loadBrandingLogo = async () => {
      if (!authToken) return;
      try {
        const res = await getCustomerBranding(authToken);
        if (res?.data?.statusCode === "200") {
          setBrandingLogo(res?.data?.data?.logo || "");
          document.documentElement.style.setProperty(
            "--brand-primary",
            res?.data?.data?.primary_color || "#59B3C6"
          );
          document.documentElement.style.setProperty(
            "--brand-secondary",
            res?.data?.data?.secondary_color || "#000000"
          );
        }
      } catch (e) {
        setBrandingLogo("");
        document.documentElement.style.setProperty("--brand-primary", "#59B3C6");
        document.documentElement.style.setProperty("--brand-secondary", "#000000");
      }
    };
    loadBrandingLogo();
  }, [authToken]);

  const consumeSsoToken = async (token) => {
    try {
      setLoading(true);
      
      const response = await axios.post(SSO_CONSUME_URL, {
        token: token
      });
      if (response?.data?.statusCode === "200") {
        // Success - login the user
        setSuccess(true);
        setMessage("Login successful! Redirecting...");
        Mixpanel.track('LoggedIn');
        Cookies.set("conditionalLogout", false );        
        authCtx.onLogin(response?.data);
        // window.location.reload();
        const randomId = Math.floor(Math.random() * 900000) + 100000; // Generate a random token
        const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
        Cookies.set("chatid", `backend-${randomId}`, { expires: expiryDate }); // Set the cookie with the random token
        navigate("/internal_ama");
        setButtonLoader(false);
        
      } else {
        setError(true);
        setMessage(response?.data?.message || "Login failed. Please try again.");
      }
    } catch (err) {
      setError(true);
      if (err?.response?.data?.message) {
        setMessage(err.response.data.message);
      } else if (err?.response?.status === 401) {
        setMessage("Invalid or expired SSO token");
      } else if (err?.response?.status === 403) {
        setMessage("Access denied. Please contact your administrator.");
      } else {
        setMessage("Login failed. Please try again or contact support.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    const token = searchParams.get("token");
    if (token) {
      const cleanToken = token.replace(/"/g, "");
      consumeSsoToken(cleanToken);
    }
  };

  const handleGoToLogin = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="text-center">
          {/* Logo */}
          <div className="mb-8">
            {brandingLogo && <img 
              src={brandingLogo} 
              alt="Zoi Logo" 
              className="mx-auto h-20 w-auto"
            />}
          </div>

          {/* Loading State */}
          {loading && (
            <div className="space-y-4">
              <div className="flex justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[var(--brand-primary)]"></div>
              </div>
              <h2 className="text-2xl font-bold text-gray-900">
                Processing SSO Login...
              </h2>
              <p className="text-gray-600">
                Please wait while we authenticate your credentials.
              </p>
            </div>
          )}

          {/* Success State */}
          {success && !loading && (
            <div className="space-y-4">
              <div className="flex justify-center">
                <div className="rounded-full bg-green-100 p-3">
                  <Icon.CheckCircle className="h-12 w-12 text-green-600" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-green-600">
                Login Successful!
              </h2>
              <p className="text-gray-600">
                {message}
              </p>
              <div className="flex justify-center">
                <div className="animate-pulse text-[var(--brand-primary)]">
                  <Icon.ArrowRight className="h-6 w-6" />
                </div>
              </div>
            </div>
          )}

          {/* Error State */}
          {error && !loading && (
            <div className="space-y-4">
              <div className="flex justify-center">
                <div className="rounded-full bg-red-100 p-3">
                  <Icon.XCircle className="h-12 w-12 text-red-600" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-red-600">
                Login Failed
              </h2>
              <p className="text-gray-600">
                {message}
              </p>
              
              <div className="space-y-3 pt-4">
                <button
                  onClick={handleRetry}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--brand-primary)]"
                >
                  <Icon.ArrowClockwise className="h-4 w-4 mr-2" />
                  Try Again
                </button>
                
                <button
                  onClick={handleGoToLogin}
                  className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--brand-primary)]"
                >
                  <Icon.BoxArrowInRight className="h-4 w-4 mr-2" />
                  Go to Login Page
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Additional Info */}
        <div className="text-center text-sm text-gray-500">
          <p>
            Having trouble? Contact your administrator or try logging in manually.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConsumeSso;
